<template>
    <div class="bar">
        <div :id="chartId"  style="width:100%; height:100%"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    props:{
        chartId:String,
        xData:Array,
        seriesData:Array,
        seriesData2:Array,
        unit:String,

    },
    data(){
        return {
            chart:null,
            option:{
                title: {
                    text: this.unit || 'kVA',
                    x: '1%',
                    y: '-3%',
                    textStyle:{                  //标题样式
                        fontSize: '12',
                        fontFamily:'Source Han Sans CN',
                        color:'rgba(230,243,253, 0.7)',
                    }
                },
                xAxis: {
                    type: 'category',
                    // boundaryGap: false,
                    data: this.xData,
                    axisLine:{
                        lineStyle:{
                            color:'#0D94FF'
                        }
                    },
                     axisLabel: {
                        color: "rgba(230,243,253, 0.7)"  //坐标轴的文本颜色
                    },
                    axisTick:{       
                        "show":false   //去掉x轴刻度线
                    },
                },
                tooltip: {
					trigger: 'item', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
                    backgroundColor: 'rgba(0, 10, 26, 0.8)',
                    borderRadius: 8,  
                    borderWidth: 0,
                    shadowColor:'rgba(13, 148, 255, 0.8)',
					axisPointer: {// 坐标轴指示器，坐标轴触发有效
						type: 'line', // 默认为直线，可选为：'line' | 'shadow'
					},
                    textStyle: {
                        color: '#fff'
                    },  
                    
                },
                yAxis: {
                    type: 'value',
                    axisLine:{
                        show:false,
                        lineStyle:{
                            color:'rgba(230,243,253, 0.7)'
                        }
                    },
                    splitLine: {           //分割线
                        show: false,     //控制分割线是否显示
                        // lineStyle:{       //分割线的样式
                        //     color: ['rgba(43,70,126,1)'],
                        //     width: 2,
                        //     type: 'solid'
                        // }
                    },
                },
                series: [{
                        data: this.seriesData,
                        type: 'bar',
                        barWidth:'20',
                        animation:true,
                        itemStyle: {
                            normal: {
                                barBorderRadius: false,
                                color: '#0D94FF',
                                label: {
                                    show: false, //开启显示柱子上的数值
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'aqua',
                                        fontSize: 15,
                                    }
                                },
                            },
                            emphasis:{
                                    // borderWidth:2,
                                    // borderColor:'#fff',
                                    // shadowColor:'#00FFFF',
                                    // shadowBlur:10,
                                    color:new echarts.graphic.LinearGradient(0,0,0,1,[
                                    {
                                        offset:0,
                                        color:'rgba(13, 148, 255, 1)'
                                    },
                                    {
                                        offset:1,
                                        color:'rgba(13, 148, 255, 0)'
                                    },
                                ])
                            },
                        }
                    }],
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "0%",
                    top: "12%",
                    containLabel: true,
                },
            }
        }
    },
    mounted(){
        if(this.seriesData2){
            this.option.series =[{
                data: this.seriesData,
                type: 'bar',
                barWidth:'10',
                itemStyle: {
                    normal: {
                        barBorderRadius: false,
                        color: '#0D94FF',
                    }
                }
            },{
                data: this.seriesData2,
                type: 'bar',
                barWidth:'10',
                itemStyle: {
                    normal: {
                        barBorderRadius: false,
                        color: '#5AD8A6',
                    }
                }
            }]
        }
        this.initChart()
        let _this = this
        //窗口缩放后重新调整图标尺寸
        window.addEventListener('resize',()=>{
            _this.chart.resize()
        })

    },
    methods:{
        initChart(){
            let chartDom = document.getElementById(this.chartId)
            this.chart = echarts.init(chartDom)
            this.chart.clear()
            this.chart.setOption(this.option,true)
        }
    },
    watch:{
        seriesData(val){
            console.log(val);
            this.option.series[0].data = val
            this.chart.clear()
            this.initChart()
        }
    },
    beforeDestroy() {
        if (!this.chart) {
        return;
        }
        this.chart.dispose();
        this.chart = null;
    },
}
</script>

<style lang="less" scoped>
.bar{
    width: 100%;
    height: 100%;
}
</style>